import React from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TileContent from './TileContent';
import { noPaddingStyle } from './styles';
import './Tile.css';

const TileBack = ({
  tileContent,
  flipTile,
  flipLabel,
  leftInfo,
  rightInfo,
  drilldownFunc,
  drilldownLabel,
}) => (
  <Card style={noPaddingStyle}>
    <CardContent style={noPaddingStyle}>
      <div className="Tile-header Tile-header-back">
        <div className="Tile-left">
          <Typography>{leftInfo}</Typography>
        </div>
        <div className="Tile-right">
          <Typography>{rightInfo}</Typography>
        </div>
      </div>
      <div className="Tile-content-back">
        {tileContent && <TileContent>{tileContent}</TileContent>}
      </div>
      <div className="Tile-footer Tile-footer-back">
        <div className="Tile-left">
          <Button color="secondary" onClick={(e) => flipTile(e)}>
            {flipLabel}
          </Button>
        </div>
        <div className="Tile-right">
          {drilldownFunc && drilldownLabel && (
            <Button color="secondary" onClick={(e) => drilldownFunc(e)}>
              {drilldownLabel}
            </Button>
          )}
        </div>
      </div>
    </CardContent>
  </Card>
);

export default TileBack;

TileBack.defaultProps = {
  drilldownFunc: null,
  drilldownLabel: null,
};

TileBack.propTypes = {
  leftInfo: PropTypes.string.isRequired,
  rightInfo: PropTypes.string.isRequired,
  flipTile: PropTypes.func.isRequired,
  flipLabel: PropTypes.string.isRequired,
  drilldownFunc: PropTypes.func,
  drilldownLabel: PropTypes.string,
};
